module.exports = __webpack_public_path__ + "img/TRT_logo_serif.f3542726.png";